import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Controller, useForm } from "react-hook-form";

const ClientInfoForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, mode = "new", loading = false } = props;

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
    getValues,
  } = useForm({
    defaultValues: defaultValues ?? null,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    isSubmitSuccessful: () => isSubmitSuccessful,
    getValues,
  }));

  const validate = (evt) => {
    var theEvent = evt || window.event;
    var key;
    // Handle paste
    if (theEvent.type === "paste") {
      key = theEvent.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[^0-9۰-۹]/g;
    if (regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12} lg={3}>
          <Controller
            name='first_name'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <TextField
                {...field}
                label='نام'
                size='small'
                margin='dense'
                variant='outlined'
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors?.first_name}
                helperText={errors?.first_name?.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='last_name'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <TextField
                {...field}
                label='نام خانوادگی'
                size='small'
                margin='dense'
                variant='outlined'
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors?.last_name}
                helperText={errors.last_name?.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='phone_number'
            control={control}
            rules={{
              required: "فیلد نمیتواند خالی باشد",
              // pattern: { value: /^(0)[0-9]{10}$/, message: "شماره موبایل وارد شده ولی اشتباه است" },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label='تلفن همراه'
                size='small'
                margin='dense'
                variant='outlined'
                onKeyPress={validate}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors?.phone_number}
                helperText={errors?.phone_number?.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='gender'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={["خانم", "آقا"]}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='جنسیت'
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    error={errors?.gender}
                    helperText={errors?.gender?.message}
                  />
                )}
                onChange={(_, data) => field.onChange(data)}
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default ClientInfoForm;
